<script>
    export let databaseKey;
    export let dataKey;

    async function exportTransactions() {
        console.warn('exporting is disabled');
    }
</script>

<div class="row card">
    <button type="button" on:click={exportTransactions} disabled="true"
        >Export</button
    >
</div>

<style>
    button {
        padding-top: 0px;
        padding-bottom: 2px;
        padding-left: 5px;
        padding-right: 5px;
        margin: 0;
    }
</style>
